define(
    'views/secured/explorer/explorer.html',[
        "durandal/system",
        "services/log",
        "services/config",
        "services/eventbroker",
        "helper/appLayoutHelper",
    ],
    function (system, log, config, eventBroker, helper) {

        function compositionComplete(html, parentHtml, context) {

            var self = this;

            // note: you have to layout your jquery.ui.layouts from outer most to inner most in order.

            var completed = helper.compositionComplete(html, parentHtml, context);

            return completed.done(function () {
                var options = {
                    applyDemoStyles: true,

                    west__size: getNavigationPanelSize(context.model),
                    east__size: getPreviewPanelSize(context.model),
                    east__maskContents: true,
                    spacing_open: 4,
                    spacing_closed: 7,
                    slidable: false,
                    fxName: "none",
                    scrollToBookmarkOnLoad: false, // note: interferes with durandal routing.
                    
                    onresize: function (pane, element, state) {

                        if (pane == "east") {
                            eventBroker.trigger(self, config.events.explorer.layout.resizedDetailsPane, window.fp.explorerLayout);
                            updatePreviewPanelSize(context.model, state.layoutWidth);
                        }

                        if (pane == "west") {
                            eventBroker.trigger(self, config.events.explorer.layout.resizedNavigationPane, window.fp.explorerLayout);
                            updateNavigationPanelSize(context.model, state.layoutWidth);
                        }

                        eventBroker.trigger(self, config.events.explorer.layout.resizedResultsPane, window.fp.explorerLayout);

                    },
                };

                var layoutContainer = $(html).find("div:first");
                
                layoutContainer.css({ visibility: "hidden", display: "block"});

                window.fp = window.fp || {};
                window.fp.explorerLayout = layoutContainer.layout(options);

                layoutContainer.css({ visibility: "" });

                context.model.isVisible(true);

                var breakPoint = getBreakPoint();

                if (breakPoint < 1280)
                    window.fp.explorerLayout.close("east");                

                window.fp.explorerLayout.options.west.onopen_start = function () {
                    if (getBreakPoint() < 1280)
                        window.fp.explorerLayout.close("east");
                };

                window.fp.explorerLayout.options.east.onopen_start = function () {
                    if (getBreakPoint() < 1280)
                        window.fp.explorerLayout.close("west");
                };

                eventBroker.on(self, config.events.explorer.layout.toggleNavigation, function () {
                    window.fp.explorerLayout.toggle("west");
                });

                eventBroker.on(self, config.events.explorer.layout.toggleDetails, function () {
                    window.fp.explorerLayout.toggle("east");
                });

                eventBroker.trigger(self, config.events.explorer.layout.resizedDetailsPane, window.fp.explorerLayout);
                eventBroker.trigger(self, config.events.explorer.layout.resizedResultsPane, window.fp.explorerLayout);
             
                $("#explorer-details").off("dragenter");
                $("#explorer-details").on("dragenter", function (e) {

                    eventBroker.trigger(self, config.events.explorer.results.dropzoneShow, { isShow : false});

                    e.preventDefault();
                });
                $("#explorer-details").off("drop");
                $("#explorer-details").on("drop", function (e) {

                    e.preventDefault();
                    e.stopPropagation();
                });
                
                $("#explorer-navigation").off("dragenter");
                $("#explorer-navigation").on("dragenter", function (e) {

                    eventBroker.trigger(self, config.events.explorer.results.dropzoneShow, { isShow: false });

                    e.preventDefault();
                });
                $("#explorer-navigation").off("drop");
                $("#explorer-navigation").on("drop", function (e) {

                    e.preventDefault();
                    e.stopPropagation();
                });

                $("#explorer-results").off("dragenter");
                $("#explorer-results").on("dragenter", function (e) {

                    eventBroker.trigger(self, config.events.explorer.results.dropzoneShow, { isShow: false });

                    e.preventDefault();
                });
                $("#explorer-results").off("drop");
                $("#explorer-results").on("drop", function (e) {

                    e.preventDefault();
                    e.stopPropagation();
                });
                
                return $.when(true);
            });
            
        };

        return {
            compositionComplete: compositionComplete
        };

        //#region Internal Methods

        function getBreakPoint() {
            var viewportWidth = $(window).width();
            var breakPoint = viewportWidth <= 1024 ? 768 : viewportWidth <= 1280 ? 1024 : 1280;
            return breakPoint;
        }

        function getNavigationPanelSize(viewModel) {
            var size = 325;
            try {
                var key = String.format("navigation-panel-width-{0}", getBreakPoint() < 1280 ? "ld" : "hd");
                var value = viewModel.session.settings()[key]();
                return value ? parseInt(value) : size;
            }catch(ex){
                return size;
            }
        }

        function getPreviewPanelSize(viewModel) {
            var size = 500;
            try{
                var key = String.format("preview-panel-width-{0}", getBreakPoint() < 1280 ? "ld" : "hd");
                var value = viewModel.session.settings()[key]();
                return value ? parseInt(value) : size;
            }catch(ex){
                return size;
            }
        }

        function updateNavigationPanelSize(viewModel, width) {            
            var key = String.format("navigation-panel-width-{0}", getBreakPoint() < 1280 ? "ld" : "hd");
            var setting = viewModel.session.settings()[key];
            if (setting) {
                setting(width.toString());

                viewModel.session.settings(ko.mapping.toJS(viewModel.session.settings()));
            }
        }

        function updatePreviewPanelSize(viewModel, width) {
            var key = String.format("preview-panel-width-{0}", getBreakPoint() < 1280 ? "ld" : "hd");
            var setting = viewModel.session.settings()[key];
            if (setting) {
                setting(width.toString());
                
                viewModel.session.settings(ko.mapping.toJS(viewModel.session.settings()));
            }
        }

        //#endregion Internal Methods

});
